import React from "react";

import PageWrapper from "../../../components/layout/page/PageWrapper";

import HomeHero from "../components/hero/HomeHero";
import TalentPromo from "../components/promo/TalentPromo";

import HomeVideosView from "../../videos/home/views/HomeVideosView";
import HomePopsView from "../../pops/home/views/HomePopsView";
import HomeAlbumsView from "../../albums/home/views/HomeAlbumsView";

import "./HomePage.css";

export default function HomePage() {
  return (
    <PageWrapper>
      <div className="katch-home">
        <HomeHero />

        <HomeVideosView />

        <TalentPromo />

        <HomePopsView />

        <HomeAlbumsView />
      </div>
    </PageWrapper>
  );
}
